import type { UserRole } from '@kn/shared';

export interface NavigationEntry {
  label: string;
  path: string;
  /** Les entrees des phases suivantes sont affichees mais non cliquables. */
  enabled: boolean;
  /** Roles autorises ; absent = tous les roles connectes. */
  roles?: UserRole[];
  /**
   * Entree **rattachee** a celle qui la precede : elle appartient au meme
   * module et se lit indentee sous lui.
   *
   * « Historique » n'est pas un module : c'est la memoire de ce qu'on a fait
   * depuis le Restant. Le poser au meme niveau laissait croire a une
   * fonctionnalite autonome, et on le cherchait comme telle.
   */
  rattachee?: boolean;
}

export interface NavigationSection {
  /** Intitule du groupe, ou `null` pour les entrees de premier niveau. */
  label: string | null;
  entries: NavigationEntry[];
}

/**
 * Navigation laterale. Les entrees desactivees materialisent le perimetre cible
 * du produit ; elles sont activees phase par phase.
 */
export const NAVIGATION: NavigationSection[] = [
  {
    label: null,
    entries: [
      { label: 'Tableau de bord', path: '/tableau-de-bord', enabled: true },
      { label: 'Imports', path: '/imports', enabled: true },
      { label: 'Rapprochement', path: '/rapprochement', enabled: true },
      { label: 'Journal', path: '/journal', enabled: false },
      { label: 'Stocks', path: '/stocks', enabled: false },
      { label: 'Écarts', path: '/ecarts', enabled: true },
      { label: 'Restant à expliquer', path: '/restant', enabled: true },
      { label: 'Historique', path: '/restant/historique', enabled: true, rattachee: true },
      { label: "Clôture annuelle", path: '/cloture', enabled: true },
    ],
  },
  {
    label: 'Référentiels',
    entries: [
      { label: 'Articles', path: '/referentiels/articles', enabled: true },
      { label: 'Types de mouvements', path: '/referentiels/types-de-mouvements', enabled: true },
      { label: "Familles d'équivalence", path: '/referentiels/familles', enabled: true },
      { label: 'Cohérence copacking', path: '/referentiels/copacking', enabled: true },
      { label: 'Types de commentaire', path: '/referentiels/types-de-commentaire', enabled: true },
      {
        label: 'Types de rapprochement',
        path: '/referentiels/types-de-rapprochement',
        enabled: true,
      },
    ],
  },
  {
    label: 'Administration',
    entries: [
      {
        label: 'Utilisateurs',
        path: '/administration/utilisateurs',
        enabled: true,
        roles: ['ADMIN'],
      },
    ],
  },
];
